import React, { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import DatePicker from "../DatePicker/DatePicker";
import "./LSQDateSelector.css"; // Import the CSS file

const LSQDateSelector = ({ selectedDate, setSelectedDate, onDateClick, ...props }) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const datePickerRef = useRef(null);

  const nextDay = () => {
    setSelectedDate(new Date(selectedDate.setDate(selectedDate.getDate() + 1)));
  };

  const previousDay = () => {
    setSelectedDate(new Date(selectedDate.setDate(selectedDate.getDate() - 1)));
  };

  const handleDateClick = (value) => {
      onDateClick && onDateClick();
      setIsDatePickerOpen(value);
  };

  return (
    <div className="lsq-date-selector ng_p_2_b" {...props}>
      <ChevronLeft
        size={16}
        onClick={previousDay}
        role="chevron-left"
        className="chevron-left"
      />
      <span
        className="date-display ng_p_1_sb"
        onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
        ref={datePickerRef}
      >
        {selectedDate.toLocaleDateString("en-US", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </span>
      <ChevronRight
        size={16}
        onClick={nextDay}
        role="chevron-right"
        className="chevron-right"
      />
      {isDatePickerOpen && (
        <DatePicker
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          setIsDatePickerOpen={handleDateClick}
        />
      )}
    </div>
  );
};

export default LSQDateSelector;
